var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGuests = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.175 13h-3.238C7.657 13 5 16.03 5 19.77c0 .679.483 1.23 1.08 1.23h12.952c.596 0 1.08-.551 1.08-1.23 0-3.74-2.659-6.77-5.937-6.77zm-7.523 6.154c.267-2.427 2.085-4.308 4.285-4.308h3.238c2.197 0 4.017 1.883 4.283 4.308H6.652zm5.904-6.654c2.384 0 4.317-1.903 4.317-4.25S14.94 4 12.556 4C10.17 4 8.238 5.903 8.238 8.25s1.933 4.25 4.318 4.25zm0-6.906c1.487 0 2.698 1.191 2.698 2.656s-1.21 2.656-2.698 2.656S9.857 9.714 9.857 8.25c0-1.465 1.211-2.656 2.699-2.656z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGuests, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/guests.b5908b9e.svg";
export { ForwardRef as ReactComponent };